export default __webpack_public_path__ + "static/media/softball.4b6e6677.jpg";